import request from "@/utils/request"

export default function agentWithdraw(params) {
    return request({
        url: `/fund/withdrawLog/agentWithdraw`,
        params: params
    })
}
